import {
  annotationsSelectors,
  applicationActions,
  useAppDispatch,
} from '@readcloud/state';
import React from 'react';
import { useSelector } from 'react-redux';

export const usePDFToggleToolbarsListener = (window?: Window) => {
  const selectedAnnotation = useSelector(
    annotationsSelectors.getSelectedAnnotation
  );
  const dispatch = useAppDispatch();

  const prevSelectionRef = React.useRef<string>('');

  React.useEffect(() => {
    const doc = window?.document || document;
    const clickListener = (e) => {
      if (e.target instanceof Element) {
        const selection = doc?.getSelection();

        // Since the selection can only be text or annotation, we check to see what is currently selected,
        // prioritizing annotations.
        const currentSelection =
          selectedAnnotation?.id || selection?.toString() || '';

        //if this selection was the same as last click, we toggle the toolbars.
        if (
          currentSelection === prevSelectionRef.current &&
          e.target.closest('#clickaway-listener')
        ) {
          dispatch(applicationActions.toggleToolbars());
        }

        //save this selection to compare to next click
        prevSelectionRef.current = currentSelection;
      }
    };

    doc.addEventListener('click', clickListener);
    return () => doc.removeEventListener('click', clickListener);
  }, [selectedAnnotation?.id]);
};
